<template>
  <v-container fluid>
    <v-navigation-drawer app
                         v-model="drawer"
                         dark
                         disable-resize-watcher
                         class="primary">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="">
            KANU NOMINATIONS PORTAL
          </v-list-item-title>
          <v-list-item-subtitle>
            The smart way to manage nominations
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense
              nav>
        <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.to"
            link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
    <!--        <system-bar/>-->
    <v-app-bar color="primary" dark app>
      <v-app-bar-nav-icon
          class="hidden-md-and-up"
          @click="drawer = !drawer"/>
      <v-spacer class="hidden-md-and-up"/>
      <v-toolbar-title class="">KANU NOMINATIONS PORTAL</v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-btn text exact to="/" data-cy="signinBtn">Home</v-btn>
        <v-btn text exact to="/nominations" data-cy="signinBtn">Apply For Nominations</v-btn>
<!--        <v-menu left bottom offset-y>-->
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-btn text v-on="on">-->
<!--              Solutions-->
<!--            </v-btn>-->
<!--          </template>-->

<!--          <v-list width="300px">-->
<!--            <v-list-item v-for="(solution,i) in solutions"-->
<!--                         :key="i"-->
<!--                         :to="solution.to">-->
<!--              <v-list-item-title>{{ solution.name }}</v-list-item-title>-->
<!--            </v-list-item>-->
<!--          </v-list>-->
<!--        </v-menu>-->
        <v-btn text exact to="/login" data-cy="signinBtn">My Account</v-btn>
      </div>
    </v-app-bar>
  </v-container>
</template>

<script>
// import SystemBar from "./home/SystemBar";

export default {
  name: "LandingNavigation",
  // components: {SystemBar},
  data() {
    return {
      drawer: false,
      items: [
        {title: 'Home', icon: 'mdi-home', to: "/"},
        {title: 'Apply For Nomination', icon: 'mdi-bank', to: "/nominations"},
        // {title: 'Cold Chain Solutions', icon: 'mdi-thermometer', to: '/cold-chain-solutions'},
        // // {title: 'GPS Tracking Solutions', icon: 'mdi-map-marker', to: '/cold-chain-solutions'},
        {title: 'My Account', icon: 'mdi-login', to: "/login"},

      ],
      solutions: [
        {name: 'Cold Chain solutions', value: 'cold', to: '/cold-chain-solutions'},
        {name: 'GPS Tracking solutions', value: 'cold'},
        // {name: 'Lora Network solutions', value: 'cold'},
      ]
   }
  }
}
</script>

<style scoped>

</style>